
export default {
  name: "ImageCard",
  props: {
    fileName: String,
  },
};
